module.exports = __webpack_public_path__ + "static/team-communication-and-scheduling-app-for-construction-workers-e8bbe1959870f7ce3a175067e4f28d02.png";